import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, Subscription } from 'rxjs';
import { CustomerAccountType } from 'src/app/_enums/customer-account-type.enum';
import { DocumentType } from 'src/app/_enums/document-type.enum';
import { FamilyMemberType } from 'src/app/_enums/family-member-type.enum';
import {
  BUSINESS_INSURANCES,
  getInsuranceTypeLabel,
  InsuranceType,
  PERSONAL_INSURANCES,
} from 'src/app/_enums/insurance-type.enum';
import {
  getPeriodicityByInsuranceType,
  getPeriodicityLabel,
  getPeriodicityMultiplier,
  Periodicity,
  PolicyStatus,
} from 'src/app/_enums/proposal.enums';
import { CustomValidators } from 'src/app/_helpers/CustomValidators';
import { FileSizePipe } from 'src/app/_pipes/file-size.pipe';
import { UserAuthService } from 'src/app/_services/user-auth.service';
import { FamilyMember, User } from 'src/app/_types/auth.types';
import {
  APICategory,
  FormProduct,
  Product,
} from 'src/app/_types/product.types';
import { Globals } from 'src/app/globals';
import {
  ProductItemFormGroup,
  ProductSelectionComponent,
} from 'src/app/shared/components/add-proposal-modal/product-selection/product-selection.component';
import { SlideInModalComponent } from 'src/app/shared/components/slide-in-modal/slide-in-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { v4 } from 'uuid';

export interface PolicyAddedEvent {
  proposalId: string;
}

@Component({
  selector: 'app-add-contract-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    SlideInModalComponent,
    ProductSelectionComponent,
    FileSizePipe,
    IconsModule,
  ],
  templateUrl: './add-existing-contract.component.html',
  styleUrls: ['./add-existing-contract.component.css'],
})
export class AddExistingContractComponent implements OnInit, OnDestroy {
  @Input('userId')
  customer_id!: string;

  @Input()
  familyMemberId: string;

  @Input()
  centralisationId: string;

  @Input()
  insuranceType?: InsuranceType | null;

  @Input()
  insurer?: string | null;

  formId = v4();

  private _categoryList: APICategory[] = [];

  get categoryList() {
    return this._categoryList;
  }

  set categoryList(value: APICategory[]) {
    this._categoryList = value;
    if (value) {
      this.categoryList.sort((a, b) => {
        if (this.lngCode === 'en')
          return a.category
            ?.toLowerCase()
            .localeCompare(b.category?.toLowerCase());
        return a.categoryInFrench
          ?.toLowerCase()
          .localeCompare(b.categoryInFrench?.toLowerCase());
      });
    }
  }

  private _SubcategoryList: APICategory[] = [];

  get SubcategoryList() {
    return this._SubcategoryList;
  }

  set SubcategoryList(value: APICategory[]) {
    this._SubcategoryList = value;
    if (value) {
      this.SubcategoryList.sort((a, b) => {
        if (this.lngCode === 'en')
          return a.category
            ?.toLowerCase()
            .localeCompare(b.category?.toLowerCase());
        return a.categoryInFrench
          ?.toLowerCase()
          .localeCompare(b.categoryInFrench?.toLowerCase());
      });
    }
  }

  categoryLogo: any;

  subCategoryName: any;

  private _productData: Product[] = [];

  get productData() {
    return this._productData;
  }

  set productData(value: Product[]) {
    this._productData = value;
    if (value) {
      this._productData.sort((a, b) => {
        if (this.lngCode === 'en')
          return a.productName
            ?.toLowerCase()
            .localeCompare(b.productName?.toLowerCase());
        return a.productNameInFrench
          ?.toLowerCase()
          .localeCompare(b.productNameInFrench?.toLowerCase());
      });
    }
  }

  insuranceTypeList: InsuranceType[] = [];

  all_PartnerList: any;

  all_AgentList: any;

  selectedFiles: any;

  categoryName: any;

  isProductMultiple = false;

  user: any;

  GetCustomerdata: User;

  lngmsgData: any;

  lngCode: any;

  isCompanyCustomer: boolean;

  constructor(
    private fb: FormBuilder,
    private userAuthService: UserAuthService,
    private toasterService: ToastrService,
    private router: Router,
    private cookieService: CookieService,
    private globals: Globals
  ) {
    const data: any = localStorage.getItem('user');
    if (data != null) {
      this.user = JSON.parse(data);
    }
  }

  existingContracts = this.fb.group(
    {
      policyId: ['', Validators.required],
      categoryId: ['', Validators.required],
      partnerId: ['', []],
      subCategoryId: ['', Validators.required],
      agentId: ['', []],
      product: new FormControl([], [Validators.required]),
      insuranceType: new FormControl<InsuranceType | null>(
        null,
        Validators.required
      ),
      totalAmount: [0, Validators.required],
      premiumAmount: [0, Validators.required],
      periodicity: ['', Validators.required],
      coversPeriodicity: new FormControl<Periodicity>(Periodicity.YEAR),
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      productList: this.fb.array<FormGroup<ProductItemFormGroup>>(
        [],
        [Validators.required]
      ),
      familyMemberId: ['', Validators.required],
      managedByLty: [true],
      categoryName: [''],
      categoryNameInFrench: [''],
      categoryLogo: [''],
      subCategoryName: [''],
      subCategoryNameInFrench: [''],
    },
    {
      validators: [CustomValidators.dateAfter('endDate', 'startDate')],
    }
  );

  pstep1: any = [];

  productListSubscription!: Subscription;

  periodicitySubscription!: Subscription;

  insuranceTypeSubscription!: Subscription;

  subcategorySubscription!: Subscription;

  categorySubscription!: Subscription;

  coversPeriodicitySubscription!: Subscription;

  ngOnInit(): void {
    this.lngmsgData = this.globals._getLangMessageData();
    this.lngCode = this.cookieService.get('selectedCountryCode').substr(0, 2);
    if (this.customer_id && this.customer_id !== '') {
      this.GetCustomerDetail();
    }
    this.getPartnerList();
    if (this.customer_id && this.customer_id !== '')
      this.fetchFamilyMembers(this.customer_id);

    this.productListSubscription =
      this.existingContracts.controls.productList.valueChanges.subscribe(
        (pdata) => {
          this.setTotalAmount(
            pdata,
            this.existingContracts.value.coversPeriodicity
          );
        }
      );

    this.periodicitySubscription =
      this.existingContracts.controls.periodicity.valueChanges.subscribe(
        (periodicityVal) => {
          this.setPremiumAmount(
            this.existingContracts.value.totalAmount ?? 0,
            periodicityVal as Periodicity
          );
        }
      );

    this.coversPeriodicitySubscription =
      this.existingContracts.controls.coversPeriodicity.valueChanges.subscribe(
        (coverPeriodicity) => {
          this.setTotalAmount(
            this.existingContracts.controls.productList.value,
            coverPeriodicity
          );
        }
      );

    this.insuranceTypeSubscription =
      this.existingContracts.controls.insuranceType.valueChanges.subscribe(
        (type) => {
          this.existingContracts.controls.coversPeriodicity.setValue(
            getPeriodicityByInsuranceType(type)
          );
        }
      );
  }

  // The covers periodicity field will be used to compute the total amount due
  // The (payment) periodicity will be used to compute the premium amount
  setTotalAmount(
    productsList: Partial<FormProduct>[],
    coversPeriodicity: Periodicity
  ) {
    let totalAmount = 0;
    for (let i = 0; i < productsList.length; i++) {
      totalAmount += !Number.isNaN(productsList[i].amount)
        ? (productsList[i].amount as number)
        : 0;
    }
    totalAmount *= getPeriodicityMultiplier(coversPeriodicity);
    this.existingContracts.controls.totalAmount.setValue(
      parseFloat(totalAmount.toFixed(2))
    );
    if (totalAmount > 0) {
      const { periodicity } = this.existingContracts.value;
      this.setPremiumAmount(totalAmount, periodicity as Periodicity);
    }
  }

  setPremiumAmount(totalAmount: number, periodicity: Periodicity = null) {
    this.existingContracts.controls.premiumAmount.setValue(
      parseFloat(
        (totalAmount / getPeriodicityMultiplier(periodicity)).toFixed(2)
      )
    );
  }

  get contractError() {
    return this.existingContracts.controls;
  }

  categoryListFetchSubject = new Subject<boolean>();

  getPartnerList() {
    this.userAuthService.partners({}).subscribe({
      next: (x: any) => {
        this.all_PartnerList = x.data.agentsList;
      },
    });
  }

  getAgentList(): Observable<boolean> {
    const subject = new Subject<boolean>();
    this.userAuthService
      .Allagents({
        partnerId: this.existingContracts.value.partnerId,
        searchBy: '',
        agentState: '',
      })
      .subscribe({
        next: (x: any) => {
          this.all_AgentList = x.data.agentsList;
          subject.next(true);
        },
      });
    return subject;
  }

  _AddContractSubmit() {
    if (
      !this.policyFiles ||
      this.policyFiles.length === 0 ||
      this.existingContracts.invalid
    ) {
      this.toasterService.error(
        this.lngmsgData[`Fillallerror_${this.lngCode}`]
      );
      return;
    }
    if (this.submitted) return;
    this.submitted = true;

    // Upload all files first
    this.userAuthService
      .uploadDocuments(
        this.policyFiles,
        this.customer_id,
        this.existingContracts.value.familyMemberId || '',
        DocumentType.OTHER
      )
      .subscribe({
        next: (uploadedDocuments) => {
          const start_date: any = this.existingContracts.value.startDate;
          const end_date: any = this.existingContracts.value.endDate;
          const formdata = {
            partnerId: this.existingContracts.value.partnerId,
            policyId: this.existingContracts.value.policyId,
            insuranceType: this.existingContracts.value.insuranceType,
            startDate: new Date(start_date).toISOString(),
            endDate: new Date(end_date).toISOString(),
            offerType: 'EXISTING',
            periodicity: this.existingContracts.value.periodicity,
            coversPeriodicity: this.existingContracts.value.coversPeriodicity,
            premiumAmount: this.existingContracts.value.premiumAmount,
            memberId: this.customer_id,
            agentId: this.existingContracts.value.agentId,
            totalAmount: this.existingContracts.value.totalAmount,
            familyMemberId: this.existingContracts.value.familyMemberId,
            categoryDetails: {
              categoryId: this.existingContracts.value.categoryId,
              categoryName: this.existingContracts.value.categoryName,
              categoryNameInFrench:
                this.existingContracts.value.categoryNameInFrench,
              categoryLogo: this.existingContracts.value.categoryLogo,
              subCategoryId: this.existingContracts.value.subCategoryId,
              subCategoryName: this.existingContracts.value.subCategoryName,
              subCategoryNameInFrench:
                this.existingContracts.value.subCategoryNameInFrench,
            },
            productDetails: {
              productList: this.existingContracts.value.productList,
            },
            contractDoc: uploadedDocuments.map(
              (document) => document.documentId
            ),
            policyStatus: PolicyStatus.ACTIVE,
            managedByLty: this.existingContracts.value.managedByLty,
            centralisationId: this.centralisationId,
          };

          this.userAuthService._AddExistingContract(formdata).subscribe({
            next: (x: any) => {
              this.toasterService.success(
                this.lngmsgData[`contractAdd_${this.lngCode}`]
              );
              this.policyAdded.emit({ proposalId: x?.data?.proposalId });
              this.closeModal();
              this.resetForm();
            },
            error: (err: Error) => {
              let errRes: any;
              errRes = err;
              if (this.lngCode == 'fr') {
                this.toasterService.error(
                  errRes?.error?.error?.clientErrorMessageInFrench
                );
              } else {
                this.toasterService.error(
                  errRes?.error?.error?.clientErrorMessage
                );
              }
              this.submitted = false;
            },
          });
        },
        error: () => {
          this.toasterService.error(
            $localize`Une erreur est survenue lors du téléchargement du document`
          );
          this.submitted = false;
        },
      });
  }

  removeCatProduct(i: number) {
    this.productList.removeAt(i);
  }

  get productList(): FormArray {
    return (<FormArray>this.existingContracts.get('productList')) as FormArray;
  }

  GetCustomerDetail(): any {
    this.userAuthService
      .getCustomerDetail({
        entityId: this.customer_id,
        entityType: 'USER_ID',
      })
      .subscribe({
        next: (x: any) => {
          this.GetCustomerdata = x.data;
          this.isCompanyCustomer = x.data.type === CustomerAccountType.COMPANY;
          this.insuranceTypeList = (
            this.isCompanyCustomer ? BUSINESS_INSURANCES : PERSONAL_INSURANCES
          ).filter((x) => x !== InsuranceType.CENTRALISATION);
          if (
            this.existingContracts?.controls?.partnerId &&
            this.GetCustomerdata.partnerId
          ) {
            this.existingContracts.controls.partnerId.setValue(
              this.GetCustomerdata.partnerId
            );
            if (
              this.existingContracts?.controls?.agentId &&
              this.GetCustomerdata.agentId
            ) {
              this.getAgentList().subscribe({
                next: () => {
                  this.existingContracts.controls.agentId.setValue(
                    this.GetCustomerdata.agentId
                  );
                },
              });
            }
          }
        },
        error: (err: Error) => {
          let errRes: any;
          errRes = err;
        },
        complete: () => {},
      });
  }

  getInsuranceTypeLabel = getInsuranceTypeLabel;

  familyMembers: FamilyMember[] = [];

  fetchFamilyMembers(userId: string) {
    this.userAuthService.familymembers({ userId }).subscribe({
      next: (res) => {
        this.familyMembers = res.data.familyMemberList;
        if (this.isCompanyCustomer) {
          this.existingContracts.controls.familyMemberId.setValue(
            this.familyMembers.find(
              (x) => x.memberType === FamilyMemberType.SELF
            ).familyMemberId
          );
        }
      },
    });
  }

  Periodicity = Object.values(Periodicity);

  getPeriodicityLabel = getPeriodicityLabel;

  @ViewChild('modal') modal!: SlideInModalComponent;

  submitted = false;

  @Output()
  policyAdded = new EventEmitter<PolicyAddedEvent>();

  openModal(userId?: string) {
    if (userId !== undefined) {
      this.customer_id = userId;
    }
    this.resetForm();
    this.modal.openModal();
  }

  closeModal() {
    this.modal.closeModal(false);
  }

  policyFiles: File[] = [];

  onDocumentUpload(event: Event) {
    const uploadedFiles: File[] = Array.from(
      (event.target as HTMLInputElement).files!
    );
    uploadedFiles.forEach((file) => {
      if (
        !this.policyFiles.some(
          (f) =>
            f.type === file.type && f.size === file.size && f.name === file.name
        )
      ) {
        this.policyFiles.push(file);
      }
    });
  }

  removeFile(index: number) {
    this.policyFiles.splice(index, 1);
  }

  @ViewChild('productSelection')
  productSelectionComponent: ProductSelectionComponent;

  resetForm() {
    this.existingContracts.reset();
    this.SubcategoryList = [];
    this.productData = [];
    this.policyFiles = [];
    this.familyMembers = [];
    if (this.customer_id && this.customer_id !== '')
      this.fetchFamilyMembers(this.customer_id);
    if (this.familyMemberId)
      this.existingContracts.controls.familyMemberId.setValue(
        this.familyMemberId
      );
    this.submitted = false;
    this.productSelectionComponent.resetProductSelection();
    if (this.insuranceType) {
      this.existingContracts.controls.insuranceType.setValue(
        this.insuranceType
      );
      this.productSelectionComponent.findChosenInsurer(false);
    }
    this.GetCustomerDetail();
  }

  ngOnDestroy(): void {
    if (this.productListSubscription)
      this.productListSubscription.unsubscribe();
    if (this.periodicitySubscription)
      this.periodicitySubscription.unsubscribe();
    if (this.insuranceTypeSubscription)
      this.insuranceTypeSubscription.unsubscribe();
    if (this.subcategorySubscription)
      this.subcategorySubscription.unsubscribe();
    if (this.categorySubscription) this.categorySubscription.unsubscribe();
    if (this.coversPeriodicitySubscription)
      this.coversPeriodicitySubscription.unsubscribe();
  }
}
